import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-kucunguanli",
  "use": "icon-kucunguanli-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-kucunguanli\"><path d=\"M1003.584 838.869333l-480 182.890667a32.256 32.256 0 0 1-23.04 0l-480-184.810667a31.850667 31.850667 0 0 1-20.48-29.866666V212.458667a31.125333 31.125333 0 0 1 5.12-19.2h3.84a30.570667 30.570667 0 0 1 7.68-10.837334h4.48L500.586667 2.133333a32.128 32.128 0 0 1 22.4 0l482.496 185.429334h4.501333a31.210667 31.210667 0 0 1 5.12 5.738666h3.84a31.104 31.104 0 0 1 5.098667 19.2V808.96a31.850667 31.850667 0 0 1-20.458667 29.909333zM64.106667 784.704l416 158.677333V412.565333L64.106667 257.066667v527.637333zM512.106667 65.898667L123.669333 212.458667 512.106667 356.48l388.437333-144.021333z m448 191.168l-416 155.498666v530.816L960.106667 784.064v-526.933333zM314.410667 516.416l-117.76-43.968a32 32 0 1 1 22.4-59.882667l117.738666 43.328v0.64a32 32 0 1 1-22.421333 59.882667z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/kucunguanli.svg
// module id = 1B1z
// module chunks = 5